module.exports = __webpack_public_path__ + "static/media/lightingIcon.81d41b0f.svg";